export const allProjectListInitialState = {
    allprojectList: []
};